var bookshelf = require("../index-extended");
// FIXME: meeting_has_resolution_has_media ..
// require("./BuildingOwnerVotingRight");
require("./Meeting");
require("./ResolutionVote");
require("./Resolution");
require("./Media");
require("./Majority");
require("./VotingCategory");

module.exports = bookshelf.model("MeetingResolution", {
  entityName: "MeetingResolution",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "meeting_resolution",
  // HACK: .. needed for list table .. sort by number of resolutions
  meeting() {
    return this.belongsTo("Meeting");
  },
  resolution() {
    return this.belongsTo("Resolution", "resolution_id");
  },
  resolution_votes() {
    return this.hasMany("ResolutionVote", "meeting_has_resolution_id");
  },
  // FIXME: meeting_has_resolution_has_media ..
  // building_owner_voting_rights() {
  //   return this.hasMany("BuildingOwnerVotingRight", "building_owner_has_building_lot_id");
  // },
  media() {
    return this.hasMany("Media", "meeting_has_resolution_id");
  },
  majority() {
    return this.belongsTo("Majority");
  },
  revote_majority() {
    return this.belongsTo("Majority", "revote_majority_id");
  },
  voting_category() {
    return this.belongsTo("VotingCategory");
  },
  // children meeting resolutions
  children_resolutions() {
    return this.hasMany("MeetingResolution", "parent_resolution_id");
  },

  parse(res) {
    if (res.resolution_for_reset) res.resolution_for_reset = JSON.parse(res.resolution_for_reset);
    return res;
  },
  format(attrs) {
    if (attrs.resolution_for_reset)
      attrs.resolution_for_reset = JSON.stringify(attrs.resolution_for_reset);

    delete attrs["$id"];
    delete attrs["voting_category"];
    delete attrs["majority"];
    delete attrs["resolution_votes"];
    delete attrs["parent_resolution"];
    delete attrs["media"];
    delete attrs["children_resolutions"];
    delete attrs["resolution_catalog_id"];
    delete attrs["revote_majority"];

    return attrs;
  },
});
